import { LicenseInfo } from "@mui/x-license";
// ToDo: expiry date:  Sun Oct 13 2024
export const expirationDate = new Date("2024-10-13");
export const key = "b5daacac884de32cfc511ae1055c7c3cTz03NjU2NSxFPTE3Mjg4MDcyMzkwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y";
export const InitMuiLicense = (licenceKey = key) => LicenseInfo.setLicenseKey(licenceKey);
//# sourceMappingURL=MuiLicense.js.map